import React, { useMemo, useEffect } from 'react';
import { Canvas } from './canvas';
import { SubWindows } from './windows';
import helpers from '@starflow/app/helpers';
import { useLoginStateHooks } from '@shakkerai/pro-login-modal';
import { useUserInfo, useProjectState } from '@starflow/app/store';
import { useCalcPointHooks, PurchaseShakkerModal, LibVipModal } from '@shakkerai/pro-commercial';
import { isMainland, isOverseas } from '@shakkerai/pro-utils';
import { ShareImgModal } from '@shakkerai/pro-components';
import { useBrowserTips } from '@shakkerai/pro-hooks';
import { getSearchParams } from '@shakkerai/utils';
import { Error } from './Error';
import { GuideWrapper } from './guide';
import '../assets/global.scss';

const RootComponents = React.memo(() => {
  const rootComponents = useMemo(() => {
    return helpers.component.getRootComponents().map(({ Component }, index) => <Component key={index} />);
  }, []);

  return rootComponents;
});
const CommercialEntry = React.memo(() => {
  // 监听参数变化并触发重新计算
  useCalcPointHooks();

  return (
    <>
      {isOverseas && <PurchaseShakkerModal />}
      {isMainland && <LibVipModal />}
    </>
  );
});

export const App = () => {
  const { isShow, TipNode } = useBrowserTips();
  const { showLogin, openLoginModal, LoginModal } = useLoginStateHooks();
  const userInfo = useUserInfo((state) => state.userInfo);
  const validProjectId = useProjectState('validProjectId');

  useEffect(() => {
    if (showLogin) {
      openLoginModal();
    } else {
      const searchParams = getSearchParams();
      if (Object.keys(searchParams).length === 0 && isMainland) {
        window.location.href = '/projects';
      }
    }
  }, [showLogin, openLoginModal]);

  // 监听退出登录事件多个tab
  useEffect(() => {
    const handleLogoutMessage = (event) => {
      if (event.key === '__userinfo_token__') {
        console.log('收到消息：', event.newValue);
        window.location.reload();
      }
    };
    window.addEventListener('storage', handleLogoutMessage);
    return () => {
      window.removeEventListener('storage', handleLogoutMessage);
    };
  }, []);

  // 先临时放这里, 后续再迁移
  if (!validProjectId) {
    return <Error />;
  }

  return (
    <>
      {isShow && TipNode()}
      <Canvas />
      <SubWindows />
      <RootComponents />
      <CommercialEntry />
      <ShareImgModal />
      {showLogin ? LoginModal : <GuideWrapper userInfo={userInfo} />}
    </>
  );
};
